import React from 'react';

export type ILayerContext = {
  disableEmbeddedLayering: boolean;
};

export const LayerContext = React.createContext<ILayerContext | undefined>(
  undefined,
);
LayerContext.displayName = 'LayerContext';

export const useLayerContext = (): ILayerContext =>
  React.useContext(LayerContext) || {
    disableEmbeddedLayering: false,
  };
